import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e355aa8e")
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = ["value", "selected"]
const _hoisted_3 = { class: "v-input__details" }
const _hoisted_4 = { class: "ml-4 text-error text-caption" }
_popScopeId()

import { withDefaults, watch, onMounted, ref } from 'vue'
import { required } from '@/lib/validation'
import { useField } from 'vee-validate'
import { ITriggerEvent, IStepData } from '@/interfaces/hoppermation'
import createHoppermationAPIClient from '@/clients/hoppermation'
import { AxiosInstance } from 'axios'
import eventBus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'
import { getEventLabel } from '@/lib/helper'

interface IProps {
  updateNodeData?: (data: IStepData) => void
  details?: IStepData
}


export default /*#__PURE__*/_defineComponent({
  props: {
    updateNodeData: { type: Function, required: false, default: () => ({}) },
    details: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { updateNodeData: (data: IStepData) => void, details: IStepData }
const hoppermationApiClient = ref({} as AxiosInstance)
const triggerEvents = ref([] as ITriggerEvent[])



onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
  getEvents()
})

const getEvents = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/trigger-events')
    triggerEvents.value = res.data
  } catch (error) {
    eventBus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}

const { errorMessage, value: eventName } = useField('eventName', required, {
  initialValue: props.details.eventName
})

watch(eventName, (value) => {
  props.updateNodeData({ eventName: value, eventLabel: getEventLabel(triggerEvents.value, value) })
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: _normalizeClass(["row-max", _unref(errorMessage) ? 'mb-3' : ''])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "px-4 width-full select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(eventName) ? eventName.value = $event : null))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(triggerEvents.value, ({ event, eventLabel }) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: event,
                      value: event,
                      selected: event === _unref(eventName)
                    }, _toDisplayString(eventLabel), 9, _hoisted_2))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(eventName)]
                ]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('details.trigger.eventName.hint')), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(errorMessage) ? _ctx.$t(_unref(errorMessage)) : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}
}

})